import type { SelectHTMLAttributes } from "react";

import { cx } from "@/lib/cx";

/**
 * DESIGN.md § Components groups `input` and `select` under one visual spec:
 * 44px, `border-strong`, `rounded.md`, `typography.body`. Same treatment as
 * `Input`, including the focus border-swap on top of the global ring, and
 * the same `invalid` error-state border — see `Input.tsx`'s own doc comment.
 */
export function Select({
  className,
  children,
  invalid,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { invalid?: boolean }) {
  return (
    <select
      aria-invalid={invalid ? true : undefined}
      className={cx(
        "h-tap-target-min w-full rounded-md border bg-surface px-3 text-body text-ink focus:border-border-focus",
        invalid ? "border-danger" : "border-border-input",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}
